import {del, get, patch, post, put} from './http'

/**
 * 获取底部导航栏
 */
export const getEntNavigations = () => get('goodsmanual/decorate/navigate/ent/list', {})

/**
 * 获取页面详情
 * @param id
 */
export const getPageDetail = (id) => get('goodsmanual/decorate/page/ent/' + id, {})

/**
 * 编辑装修页
 * @param id
 * @param params
 */
export const editPage = (id, params) => put('goodsmanual/decorate/page/' + id, params)

/**
 * 更新底部导航栏
 * @param params
 */
export const updateNavList = (params) => patch('goodsmanual/decorate/navigate/list', params)

/**
 * 更新底部导航栏Item
 * @param params
 */
export const updateNavItem = (params) => patch('goodsmanual/decorate/navigate/button', params)

/**
 * 设置首页
 * @param id
 */
export const setNavHome = (id) => put('goodsmanual/decorate/navigate/button/home/' + id, {})

/**
 * 导航排序
 * @param params
 */
export const setNavSort = (params) => put('goodsmanual/decorate/navigate/button/sort', params)

/**
 * 新增装修单页
 * @param params
 */
export const addPage = (params) => post('goodsmanual/decorate/page', params)

/**
 * 编辑页面基本信息
 * @param id
 * @param params
 */
export const editPageBaseInfo = (id, params) => patch('goodsmanual/decorate/page/base/' + id, params)

/**
 * 删除页面
 * @param id
 */
export const delPage = (id) => del('goodsmanual/decorate/page/' + id, {})
